<template>
    <v-list
        class="contact-select"
        dense
    >
        <v-list-item
            v-if="showTitle && tab.tab_header"
            class="pb-1"
            style="border-bottom: 1px solid var(--v-g3-base)"
        >
            <v-list-item-content>
                <v-list-item-title class="font-weight-medium subtitle-1">
                    {{ tab.tab_header }}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-for="(contact, index) in tab.contacts"
            class="list-item-compact"
            :key="index"
            @click="$emit('toggleRecipientFromSelection', contact)"
        >
            <v-list-item-icon>
                <v-icon
                    color="g4"
                    class="mr-4"
                >
                    {{ contact.email ? 'mdi-account-circle' : 'mdi-account-multiple' }}
                </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="font-weight-regular">
                    <div
                        class="body-2"
                        :class="isContactSelected(contact) ? 'primary--text font-weight-medium' : ''"
                        style="line-height: normal"
                    >
                        {{ itemText(contact) }}
                    </div>
                    <div v-if="contact.email" class="caption g4--text font-weight-medium" style="line-height: normal">
                        {{ contact.email }}
                    </div>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
import { $t } from "@/i18n";
import { ref, computed, watch, onMounted } from "@vue/composition-api";
import AccountAvatar from "@/components/AccountAvatar";

export default {
    name: "TaskAddEmailControlRecipientSubMenu",
    components: {
        AccountAvatar
    },
    props: {
        tab: {
            type: Object,
            required: true
        },
        recipients: {
            type: Array,
            required: true
        },
        showTitle: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const isContactSelected = contact => {
            return props.recipients.find(x => (contact.id && x.id === contact.id) ||
                (contact.custom_type && x.custom_type === contact.custom_type && x.custom_value === contact.custom_value && x.related_type === contact.related_type))
        }

        const itemText = (item) => {
            if (item.name && item.surname) {
                return `${item.name} ${item.surname}`
            } else if (item.name) {
                return item.name
            }

            return item.email
        }

        return {
            itemText,
            isContactSelected
        }
    }
}

</script>